/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const clientMainDataSchema = z.object({
  id: z.coerce.number().int(),
  name: z.coerce.string().min(1).max(500),
  enabled: z.boolean(),
});
